import { DIRECTION } from '~/enums'

export const getMoveDirection = (historyX, draggableBlockLeftX) => historyX.current
  .draggableBlockLeftX < draggableBlockLeftX
  ? DIRECTION.RIGHT
  : DIRECTION.LEFT
